import { Box, IconButton, Menu } from "@mui/material";
import React, { useState } from "react";

import LanguageButtonItem from "./LanguageButtonItem";
import LanguageIcon from "@mui/icons-material/Language";

const LanguageButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Otvori meni
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Zatvori meni
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box className="">
      <IconButton
        size="small"
        aria-label="show more"
        aria-haspopup="true"
        color="inherit"
        className="icon-header-color"
        onClick={handleClick}
      >
        <LanguageIcon />
      </IconButton>

      {/* Dropdown meni */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <LanguageButtonItem
          handleClose={handleClose}
          title="Srpski"
          language="sr"
          icon="/images/sr.png"
        />
        {/* <LanguageButtonItem
          handleClose={handleClose}
          title="Engleski"
          language="en"
          icon="/images/en.png"
        /> */}
        <LanguageButtonItem
          handleClose={handleClose}
          title="Hrvatski"
          language="hr"
          icon="/images/hr.png"
        />
        <LanguageButtonItem
          handleClose={handleClose}
          title="Bugarski"
          language="bg"
          icon="/images/bg.png"
        />
        <LanguageButtonItem
          handleClose={handleClose}
          title="Makedonski"
          language="mk"
          icon="/images/mk.png"
        />
        <LanguageButtonItem
          handleClose={handleClose}
          title="Bosanski"
          language="ba"
          icon="/images/ba.png"
        />
        <LanguageButtonItem
          handleClose={handleClose}
          title="Mađarski"
          language="hu"
          icon="/images/hu.png"
        />
        <LanguageButtonItem
          handleClose={handleClose}
          title="Slovenački"
          language="sl"
          icon="/images/sl.png"
        />
        <LanguageButtonItem
          handleClose={handleClose}
          title="Albanski"
          language="al"
          icon="/images/al.png"
        />
      </Menu>
    </Box>
  );
};

export default LanguageButton;
